import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { formatAlgoliaHits } from "shared/utils/formatAlgoliaHits";
import { searchTagsIndex } from "../constants";
import { Tag } from "../types";

const TAGS_KEY = "serviceTags";

export const useTagsListQuery = () => {
  return useQuery({
    queryKey: [TAGS_KEY],
    queryFn: async () => {
      const firstPageResponse = await searchTagsIndex.search<Tag>("", {
        hitsPerPage: 1000,
        page: 0,
      });

      let allHits = [...firstPageResponse.hits];
      const { nbPages } = firstPageResponse;

      if (nbPages > 1) {
        const remainingPages = Array.from(
          { length: nbPages - 1 },
          (_, i) => i + 1,
        );

        const additionalResults = await Promise.all(
          remainingPages.map((page) =>
            searchTagsIndex.search<Tag>("", {
              hitsPerPage: 1000,
              page,
            }),
          ),
        );

        additionalResults.forEach((result) => {
          allHits = [...allHits, ...result.hits];
        });
      }

      return formatAlgoliaHits<Tag>(allHits);
    },
  });
};

export const invalidateTagsListQuery = () => {
  return queryClient.invalidateQueries({ queryKey: [TAGS_KEY] });
};
